import "../../candidate-intelligence/results/styles.css";
import { useLocation, useRoute } from "wouter";
import { C, DM, UI } from "../results/ui-tokens";
import { CalibrationSteps, Shell } from "./calibration-steps";

/**
 * Standalone re-calibration page (`/labs/level-assessment/calibrate/:sessionId`).
 * The matrix (Step 1) already happened long ago, so this page only drives the
 * calibration round — provide reference profiles → evaluate → validate per
 * competency → auto-calibrate. The interactive core lives in `CalibrationSteps`,
 * which is also embedded in the create→calibrate `WorkflowShell` (where Step 1
 * runs first). Audience: CHRO / recruiter — plain-HR tone, no GEPA/prompt/matrix
 * internals.
 */
export default function LabsLevelAssessmentCalibrate() {
  const [, params] = useRoute("/labs/level-assessment/calibrate/:sessionId");
  const [, navigate] = useLocation();
  const sessionId = params?.sessionId ?? "";

  return (
    <Shell>
      <header>
        <p
          style={{
            ...UI,
            margin: 0,
            fontSize: 11,
            fontWeight: 600,
            textTransform: "uppercase",
            color: C.ink50,
          }}
        >
          Calibração do modelo
        </p>
        <h1 style={{ ...DM, margin: "2px 0 0", fontSize: 22, fontWeight: 800, color: C.ink }}>
          Ensine o modelo com perfis de referência
        </h1>
        <p style={{ ...UI, margin: "6px 0 0", fontSize: 13.5, color: C.ink70, maxWidth: 620 }}>
          Adicione profissionais cujo nível você conhece. O modelo estima, você confirma ou corrige
          cada competência, e ele aprende com as suas validações.
        </p>
      </header>

      <CalibrationSteps sessionId={sessionId} onFinish={() => navigate("/labs/level-assessment")} />
    </Shell>
  );
}
